/**
 * Formik-aware field wrapper that shows a label and validation error.
 */
import React from "react";
import { Box, Typography } from "@mui/material";
import PropTypes from "prop-types";

import VText from "./VText";
import { asObject, asString } from "utils/safeData";

/**
 * Wraps a form control with an optional required label and Formik error text.
 *
 * @param {{ label?: string, required?: boolean, name?: string, formik?: Object, children?: React.ReactNode }} props
 */
const VFormItem = (props) => {
  const { label, required, children } = props;
  const name = asString(props.name);
  const formik = asObject(props.formik);
  const touched = asObject(formik.touched);
  const errors = asObject(formik.errors);

  return (
    <Box>
      {label && (
        <Box className="mb-2">
          <VText>{label}</VText>
          {required && <VText className="text-yellow-500">*</VText>}
        </Box>
      )}

      {children}
      {touched[name] && errors[name] ? (
        <Typography color="error" className="text-sm">
          {errors[name]}
        </Typography>
      ) : null}
    </Box>
  );
};

VFormItem.propTypes = {
  label: PropTypes.string,
  required: PropTypes.bool,
  name: PropTypes.string,
  formik: PropTypes.object,
  children: PropTypes.node,
};

export default VFormItem;
